import path from 'node:path'
import type { AuthScaffoldOptions } from '@cli-types/next-adapter/init.js'
import { safeWriteFile } from '@cli-utils/files.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function scaffoldAuth({ cwd, config }: AuthScaffoldOptions): string[] {
  const created: string[] = []
  const authDir = path.resolve(cwd, config.paths.admin, 'lib', 'actions', 'auth')
  const namespace = config.frameworkConfig.next.namespace

  function write(filename: string, content: string): void {
    const outputFile = applyAdminNamespaceToPath(filename, namespace)
    const fullPath = path.join(authDir, outputFile)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(content, namespace))) {
      created.push(path.join(config.paths.admin, 'lib', 'actions', 'auth', outputFile))
    }
  }

  write('server.ts', readTemplate('lib/actions/auth/auth.ts'))
  write('client.ts', readTemplate('lib/actions/auth/client.ts'))
  write('session.ts', readTemplate('lib/actions/auth/middleware.ts'))

  return created
}
